<!-- src/App.vue -->
<template>
  <div id="app">
    <Navbar v-if="$route.path !== '/home'
           && $route.path !== '/login'
           && $route.path !== '/menu'" />
    <router-view />
  </div>
</template>

<script>
import Navbar from './components/MainHeader.vue';
export default {
  components: {
    Navbar,
  },
};
</script>
